export default __webpack_public_path__ + "../staticImages/product_set_contains.svg";